"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSchema = void 0;
const clearData_1 = require("./clearData");
const compareData_1 = require("./compareData");
const dataValue_1 = require("./dataValue");
const defaultValue_1 = require("./defaultValue");
const fixAndMergeSchema_1 = require("./fixAndMergeSchema");
const fixData_1 = require("./fixData");
const fixDateFormat_1 = require("./fixDateFormat");
const flatPropsList_1 = require("./flatPropsList");
const gpdrData_1 = require("./gpdrData");
const schemaValue_1 = require("./schemaValue");
const setData_1 = require("./setData");
const validate_1 = require("./validate");
const IOptions_1 = require("../WrappedProperty/IOptions");
class JSchema {
    constructor(schema) {
        this.schema = {};
        // this.schema={};
        if (schema) {
            this.init(schema);
        }
    }
    /**
     * ładowanie schema
     *
     * @param {(string | JSONSchema | (string | JSONSchema)[])} schema schemat lub tablica schematów
     * @memberof JSchema
     */
    init(schema) {
        const schemaList = [];
        if (Array.isArray(schema)) {
            for (const schemaItem of schema) {
                if (typeof schemaItem === 'string') {
                    schemaList.push(JSON.parse(schemaItem));
                }
                else {
                    schemaList.push(schemaItem);
                }
            }
        }
        else if (typeof schema === 'string') {
            schemaList.push(JSON.parse(schema));
        }
        else {
            schemaList.push(schema);
        }
        this.schema = (0, fixAndMergeSchema_1.fixAndMergeSchema)(schemaList);
    }
    /**
     * Domyślna wartośc na podstawie pól default ze schematu
     * @param schemaPath Ściezka schematu dla ktorej zwrocic domyslan wartosc, gdy pominieta zwraca dla pelnego schematu
     */
    /**
     * Domyślna wartośc na podstawie pól default ze schematu
     *
     * @param {boolean} [force] mimo braku ustawienia default ustawia domyślne wartości w zależności od typu
     * @param {string} [schemaPath] ścieżka schematu
     * @returns {*}
     * @memberof JSchema
     */
    defaultValue(force, schemaPath, longGuids = !!IOptions_1.defaultOptions.longGuids) {
        const schema = schemaPath ? this.schemaValue(schemaPath) : this.schema;
        if (schema) {
            return (0, defaultValue_1.defaultValue)(schema, force, undefined, { longGuids });
        }
        return null;
    }
    /**
     * Zwraca wartosc pola danych wg sciezki
     *
     * @param {*} data Pelne dane
     * @param {string} path sciezka w formacie pole.tablica[0].pole2
     * @returns {*} dane zgodne ze schematem
     * @memberof JSchema
     */
    dataValue(data, path) {
        return (0, dataValue_1.dataValue)(this.schema, data, path);
    }
    /**
     * Zwraca czesc schematu na podstawie sciezki
     * @param path sciezka w formacie pole.tablica[0].pole2
     */
    schemaValue(path) {
        return (0, schemaValue_1.schemaValue)(this.schema, path);
    }
    /**
     * Sprawdza poprawnoc danych według schematu i zawartej w nim walidacji
     * @param data dane do sprawdzenia
     * @param schema gałąź schamtu, gdy pominięto to uzywa glownej
     * @param path sciezka schamtu, gdy pusta uzywa glownej
     */
    validate(data, options, schema = null, path = '') {
        const result = (0, validate_1.validate)(schema || this.schema, data, options, path || '');
        if (result.errors.length) {
            result.valid = false;
        }
        return result;
    }
    /**
     * Porównuje dane uzywając schematu, zwraca CompareResult zawierający wynik porównania i listę róźnic
     * @param firstItem pierwszy element do porównania
     * @param secondItem drugi element do porównania
     */
    compareData(firstItem, secondItem, compareArraySize) {
        return (0, compareData_1.compareData)(this.schema, firstItem, secondItem, compareArraySize);
    }
    /**
     * Czyści dane pozostawiając tylko te zgodne ze schematem
     *
     * @param {*} data dane do wyczyszczenia
     * @param {boolean} [checkDataType] czy sprawdzac poprawnośc typów danych prostych
     * (number,integer,boolean, string), domyślnie nie
     * @returns {*} wyczyszczone dane
     * @memberof JSchema
     */
    clearData(data, checkDataType) {
        return (0, clearData_1.clearData)(this.schema, data, checkDataType);
    }
    /**
     * Anonimizuje dane wrażliwe, oznacozne jako GDPR
     * @param data dane
     * @param gdprMode trym anonimizacji
     * @returns
     */
    gdprData(data, gdprMode = '***') {
        return (0, gpdrData_1.gdprData)(this.schema, data, gdprMode);
    }
    /**
     * ustawienie danych zgodnie ze schematem
     *
     * @param {*} data obiekt reprezentujący dane docelowe
     * @param {*} value dane do zapisu
     * @param {string} path ścieżka
     * @param {*} [Vue] konstruktor Vue
     * @returns {boolean} czy udało się ustawić
     * @memberof JSchema
     */
    setData(data, value, path, fixArraySize) {
        return (0, setData_1.setData)(this.schema, data, value, path, 0, fixArraySize);
    }
    /**
     * Naprawia formaty danych typu date i date-time oraz string
     *
     * @param {*} data dane
     * @param {*} [Vue] konstruktor Vue
     * @returns {number} ile pól naprawino
     * @memberof JSchema
     */
    fixDateFormat(data) {
        return (0, fixDateFormat_1.fixDateFormat)(this.schema, data);
    }
    fixFormat(data) {
        return (0, fixDateFormat_1.fixDateFormat)(this.schema, data);
    }
    /**
     * Naprawia obiekt dodając wszystkei brakujące poja
     * @param data obiekt danych
     * @param force mimo braku wartości domyslych ustwaia wartości w polach prostych
     * @returns liczba naprawionych pól
     */
    fixData(data, force = true) {
        return (0, fixData_1.fixData)(this.schema, data, force);
    }
    /**
     * zwraca płaską listę elementów schematu
     *
     * @param {boolean} [simpleTypesOnly=false] zy zwracać tylko typy proste (pomija object i array)
     * @returns {FlatPropsListItem[]} lista zwróconych właściwości
     * @memberof JSchema
     */
    flatPropsList(simpleTypesOnly = false) {
        return (0, flatPropsList_1.flatPropsList)(this.schema, simpleTypesOnly);
    }
}
exports.JSchema = JSchema;
exports.default = JSchema;
//# sourceMappingURL=JSchema.js.map